import React from "react";
import Provider from "./Provider.js";
export default function PerItemProvider(props) {
    const { provider } = props;
    if (!provider.value) {
        props.onProviderUpdate({
            type: "per-item",
            value: { type: "constant", value: 1 },
        });
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", null,
        React.createElement("div", { className: "sum-provider-item" },
            React.createElement(Provider, { provider: provider.value, hasHiddenType: props.hasHiddenType, onProviderUpdate: (newP) => props.onProviderUpdate({
                    ...provider,
                    value: newP,
                }), formatNames: props.formatNames }),
            " ",
            "* (ilo\u015B\u0107 sztuk)")));
}
